import { IChannel } from "@Interfaces";

export type AssistantContextCandidate = {
    _id: string;
    title: string;
    source: "parent" | "subchannel";
};

const sortCandidatesByTitle = (
    left: AssistantContextCandidate,
    right: AssistantContextCandidate
) => left.title.localeCompare(right.title);

export const getAssistantContextCandidates = (
    currentChannel: IChannel | null | undefined,
    channels: IChannel[]
): AssistantContextCandidate[] => {
    if (!currentChannel) {
        return [];
    }

    const candidates = new Map<string, AssistantContextCandidate>();

    const addCandidate = (candidate: AssistantContextCandidate) => {
        if (candidate._id === currentChannel._id) {
            return;
        }

        if (!candidates.has(candidate._id)) {
            candidates.set(candidate._id, candidate);
        }
    };

    if (currentChannel.parent_channel_id) {
        const parentChannel = channels.find(
            (channel) =>
                channel._id === String(currentChannel.parent_channel_id)
        );

        if (parentChannel) {
            addCandidate({
                _id: parentChannel._id,
                title: parentChannel.title,
                source: "parent",
            });

            (parentChannel.sub_channels ?? []).forEach((subChannel) => {
                addCandidate({
                    _id: subChannel._id,
                    title: subChannel.title,
                    source: "subchannel",
                });
            });
        }
    } else {
        (currentChannel.sub_channels ?? []).forEach((subChannel) => {
            addCandidate({
                _id: subChannel._id,
                title: subChannel.title,
                source: "subchannel",
            });
        });
    }

    return Array.from(candidates.values()).sort(sortCandidatesByTitle);
};
